import { Divider, styled, Theme } from '@mui/material';

export const DividerStyled = styled(Divider)(
  ({ theme, $large }: { theme: Theme; $large: boolean }) => ({
    height: $large ? '0.8rem' : '0',
    background: $large ? theme.palette.secondary.main : 'none',
    border: $large ? 'none' : `0.1rem solid ${theme.palette.grey[200]}`,
    borderRadius: $large ? '0.4rem' : '0',
    width: $large ? '8.8rem' : '',
  })
);
